import React, { useState } from 'react';
import ModuleHeader from '../common/ModuleHeader';
import {
  ChartBarIcon,
  BanknotesIcon,
  TagIcon,
  ClipboardDocumentListIcon,
} from '@heroicons/react/24/outline';
import DepenseDashboard from './DepenseDashboard';
import DepenseList from './DepenseList';
import CategorieDepenseManager from './CategorieDepenseManager';

type TabType = 'dashboard' | 'depenses' | 'categories';

const DepenseModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('dashboard');

  const tabs = [
    {
      id: 'dashboard' as TabType,
      name: 'Tableau de bord',
      icon: ChartBarIcon,
    },
    {
      id: 'depenses' as TabType,
      name: 'Dépenses',
      icon: BanknotesIcon,
    },
    {
      id: 'categories' as TabType,
      name: 'Catégories',
      icon: TagIcon,
    },
  ];

  return (
    <div className="w-full space-y-5">
      <ModuleHeader
        title="Gestion des Dépenses"
        subtitle="Suivi, approbation et paiement des dépenses"
        icon={ClipboardDocumentListIcon}
        tabs={tabs}
        active={activeTab}
        onChange={setActiveTab}
      />

      <div className="w-full">
        {activeTab === 'dashboard' && <DepenseDashboard />}
        {activeTab === 'depenses' && <DepenseList />}
        {activeTab === 'categories' && <CategorieDepenseManager />}
      </div>
    </div>
  );
};

export default DepenseModule;
